<div class="tile hud-tile" (click)="onContextMenuSelect({ text: 'View Data' })">
  <div class="metric-card">
      <div class="metric-header">
        <h3>Mean Time to Resolve</h3>
      </div>
      <!-- Use averageMttr data if available, otherwise fall back to the old inputs -->
      <div class="metric-value">{{ averageMttr().average_mttr_hours_current !== null ? averageMttr().average_mttr_hours_current : 0 }} hrs</div>
      <div
        class="metric-comparison"
        [class.up]="(averageMttr().average_mttr_hours_current !== null ? averageMttr().average_mttr_hours_current : 0) > (averageMttr().average_mttr_hours_previous !== null ? averageMttr().average_mttr_hours_previous : 0)"
        [class.down]="(averageMttr().average_mttr_hours_current !== null ? averageMttr().average_mttr_hours_current : 0) < (averageMttr().average_mttr_hours_previous !== null ? averageMttr().average_mttr_hours_previous : 0)"
      >
        @if ((averageMttr().average_mttr_hours_current !== null ? averageMttr().average_mttr_hours_current : 0) < (averageMttr().average_mttr_hours_previous !== null ? averageMttr().average_mttr_hours_previous : 0)) {
          <span>↓</span>
        }
        @if ((averageMttr().average_mttr_hours_current !== null ? averageMttr().average_mttr_hours_current : 0) > (averageMttr().average_mttr_hours_previous !== null ? averageMttr().average_mttr_hours_previous : 0)) {
          <span>↑</span>
        }
        {{ averageMttr().average_mttr_hours_pct_change !== undefined ? Math.abs(averageMttr().average_mttr_hours_pct_change) : (Math.abs((((averageMttr().average_mttr_hours_current !== null ? averageMttr().average_mttr_hours_current : 0) - (averageMttr().average_mttr_hours_previous !== null ? averageMttr().average_mttr_hours_previous : 0)) / (averageMttr().average_mttr_hours_previous !== null ? averageMttr().average_mttr_hours_previous : 1)) * 100) | number: '1.1-1') }}% vs Last Period
      </div>
      <div class="metric-subtext">Previous: {{ averageMttr().average_mttr_hours_previous !== null ? averageMttr().average_mttr_hours_previous : 0 }} hrs</div>
  </div>
</div>


<kendo-dialog
  *ngIf="showPopup"
  (close)="close()"
  [width]="'95vw'"
  [height]="'90vh'"
  [minWidth]="'800px'"
  [maxWidth]="'1400px'"
>
  <kendo-dialog-titlebar>View Data</kendo-dialog-titlebar>
  <div class="dialog-content">
    <kendo-grid
      class="mxh-80v w-100"
      [filterable]="true"
      [data]="gridService | async"
      [pageable]="{
        buttonCount: 5,
        info: true,
        type: 'numeric',
        pageSizes: [25, 50, 100, 200]
      }"
      [pageSize]="gridService.state.take"
      [skip]="gridService.state.skip"
      [(filter)]="gridService.state.filter"
      [loading]="gridService.loading"
      (dataStateChange)="gridService.onStateChange($event)"
      [sort]="this.gridService.state.sort"
      [sortable]="true"
      [resizable]="true"
    >
      <ng-template kendoGridToolbarTemplate>
        <button
          type="button"
          kendoGridExcelCommand
          class="cyflare-btn-secondary"
        >
          Export to Excel
        </button>
      </ng-template>
      <kendo-grid-column
        field="created_time"
        title="Created On"
        [width]="200"
      >
      <ng-template
        kendoGridFilterCellTemplate
        let-filter
        let-column="column"
      >
        <kendo-grid-date-filter-cell
          [column]="column"
          [filter]="filter"
          [operators]="dateFilterOperators"
        ></kendo-grid-date-filter-cell>
      </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="ticket_closed_time"
        title="Closed On"
        [width]="200"
      >
      <ng-template
        kendoGridFilterCellTemplate
        let-filter
        let-column="column"
      >
        <kendo-grid-date-filter-cell
          [column]="column"
          [filter]="filter"
          [operators]="dateFilterOperators"
        ></kendo-grid-date-filter-cell>
      </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="request_id"
        title="Escalated Case #"
      ></kendo-grid-column>
      <kendo-grid-column
        field="subject"
        title="Event Name"
      ></kendo-grid-column>
      <kendo-grid-column
        field="priority"
        title="Priority"
      ></kendo-grid-column>
      <kendo-grid-excel
        fileName="mttrmetricts-data.xlsx"
        [fetchData]="allData"
      ></kendo-grid-excel>
    </kendo-grid>
  </div>
</kendo-dialog>
